import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'

import { Card, BoxProps } from '@mui/material'
import BasePageLayout from '../../layouts/BasePageLayout'
import { useTranslate } from 'react-admin'
import EditProfile from '../../components/domains/user/EditProfile'
// import UserSettings from '../../components/domains/user/UserSettings'

interface TabPanelProps extends BoxProps {
  value: number
  index: number
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...props }) => {
  return (
    <Box role='tabpanel' hidden={value !== index} {...props}>
      {value === index && <Box>{children}</Box>}
    </Box>
  )
}

const UserProfile: React.FC = () => {
  const tabs = [
    { title: 'resources.user.profile.title', element: <EditProfile /> },
    // { title: 'resources.user.setting.title', element: <UserSettings /> },
  ]
  const [activeTab, setActiveTab] = React.useState(0)
  const handleChangeTab = (e, value): void => setActiveTab(value)
  const translate = useTranslate()
  return (
    <BasePageLayout title={tabs[activeTab].title}>
      <Card>
        <Tabs
          value={activeTab}
          onChange={handleChangeTab}
          indicatorColor='primary'
          textColor='primary'
          sx={{ px: 3 }}
        >
          {tabs.map((item, idx) => (
            <Tab key={`title-${idx}`} sx={{ p: 3 }} label={translate(item.title)} />
          ))}
        </Tabs>
        {tabs.map((item, idx) => (
          <TabPanel value={activeTab} index={idx} key={`tab-panel-${idx}`}>
            {item.element}
          </TabPanel>
        ))}
      </Card>
    </BasePageLayout>
  )
}

export default UserProfile
